module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAMAAABVab95AAAAAXNSR0IArs4c6QAAADxQTFRFAAAAOl3oPGDvPF3rOV7sPF7vOl/wOmDsOV7tO1/tO17tO1/tOl7sO13sOl/tOl7sOl3sOV7sOl7tOl7sS/m6JgAAABN0Uk5TABZATVFRU2BiY2RxhYbw+vv9/o2bOzkAAAAySURBVAjXY2BAABY+DhiTTUiQC8bmpozNDGWyCgizQ1n8wryksZjgLAZOYR64gxlhDAA2vQMkV3qp9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow_r.png
// module id = lWjD
// module chunks = 0